import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1a1108",
      light: "#2a1f0e",
      dark: "#0d0a04",
    },
    secondary: {
      main: "#c9a84c",
      light: "#e2c47a",
      dark: "#a07c2d",
    },
    background: {
      default: "#f5f0e8",
      paper: "#ffffff",
    },
    text: {
      primary: "#1a1108",
      secondary: "#5a4a30",
    },
  },
  typography: {
    fontFamily: "'Lato', sans-serif",
    h1: { fontFamily: "'Playfair Display', serif", fontWeight: 700 },
    h2: { fontFamily: "'Playfair Display', serif", fontWeight: 700 },
    h3: { fontFamily: "'Playfair Display', serif", fontWeight: 600 },
    h4: { fontFamily: "'Playfair Display', serif", fontWeight: 600 },
    h5: { fontFamily: "'Playfair Display', serif", fontWeight: 500 },
    h6: { fontFamily: "'Playfair Display', serif", fontWeight: 500 },
    button: {
      fontFamily: "'Lato', sans-serif",
      fontWeight: 700,
      letterSpacing: "0.15em",
      textTransform: "uppercase",
    },
  },
  shape: { borderRadius: 2 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 0, padding: "14px 40px" },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 8 },
      },
    },
  },
});

export default theme;